<template>
  <transition name="fade">
    <div v-show="visible" class="flv-player-wrap">
      <div class="flv-player-head">
        <div class="flv-player-subtitle">
          <slot name="subtitle">{{ subtitle }}</slot>
        </div>

        <div class="flv-player-title">
          <slot name="title">{{ title || '图片管理器' }}</slot>
        </div>

        <div class="flv-player-ctrls">
          <i class="el-icon-close" @click="close"></i>
        </div>
      </div>

      <div
        class="flv-player-container"
        v-loading="loading"
        element-loading-background="#4c4b4b"
      >
        <video
          :style="playerStyle"
          id="flv-player"
          ref="player"
          controls
          autoplay
        ></video>
      </div>

      <div class="flv-player-footer"></div>
    </div>
  </transition>
</template>

<script>
import flvjs from 'flv.js'
import sleep from '@/utlis/sleep'
import { getSource } from '@/service/ykm'
import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/src/utils/resize-event'

export default {
  props: {
    yunId: String,
    subtitle: String,
    title: String,
    comId: [String, Number]
  },
  data() {
    return {
      visible: true,
      loading: true,
      source: '',
      height: 600,
      widtH: 800,
      flvPlayer: null
    }
  },
  computed: {
    playerStyle() {
      return `height: ${this.height}px;width: ${this.width}px;`
    }
  },
  mounted() {
    window.addEventListener('keyup', this.keyListener)
    addResizeListener(this.$el, this.layout)
    this.$nextTick(() => {
      this.initPlayer()
    })
  },
  methods: {
    keyListener(evt) {
      switch (evt.keyCode) {
        case 27:
          this.close() // 按键 ESC
          break
      }
    },
    async initPlayer() {
      if (!flvjs.isSupported()) {
        this.$message.error('浏览器不支持播放 Flv 视频')
      } else {
        await this.layout()
        this.getSource()
      }
    },
    async getSource() {
      if (this.yunId) {
        this.loading = true
        const [{ data }] = await Promise.all([
          getSource({
            companyId: this.comId,
            yunId: this.yunId
          }),
          sleep(1)
        ])
        this.source = data.url
        this.loading = false

        let el = this.$refs.player
        this.flvPlayer = flvjs.createPlayer({
          type: 'flv',
          isLive: false,
          withCredentials: false,
          url: data.url
        })
        this.flvPlayer.attachMediaElement(el)
        this.flvPlayer.load()
      }
    },
    layout() {
      return new Promise(resolve => {
        let height = this.$el.offsetHeight - 80
        let width = Math.ceil((height * 16) / 9)

        if (width > this.$el.offsetWidth) {
          width = this.$el.offsetWidth
          height = (this.$el.offsetWidth * 9) / 16
        }
        this.width = width
        this.height = height
        resolve()
      })
    },
    close() {
      this.visible = false
      setTimeout(() => {
        if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el)
      }, 200)
      window.removeEventListener('keyup', this.keyListener)
      removeResizeListener(this.$el, this.layout)
      this.flvPlayer && this.flvPlayer.destroy()
      this.$nextTick(function() {
        if (typeof this.onClose === 'function') {
          this.onClose()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flv-player-wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 2004;
  background-color: rgba(10, 10, 10, 0.7);
  display: flex;
  flex-direction: column;
  .flv-player-head {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 0 40px;
    background-color: rgb(10, 10, 10);
    .flv-player-title,
    .flv-player-subtitle,
    .flv-player-ctrls {
      flex: 1;
      font-size: 1.5rem;
      color: #fff;
      line-height: 60px;
    }
    .flv-player-title {
      text-align: center;
    }
    .flv-player-ctrls {
      color: #fff;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      i {
        cursor: pointer;
        line-height: 60px;
        font-size: 1.5rem;
        &:not(:first-child) {
          margin-left: 1rem;
        }
      }
    }
  }
  .flv-player-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flv-player-footer {
    display: flex;
    justify-content: space-between;
    height: 20px;
    background-color: rgb(10, 10, 10);
  }
  #flv-player {
    background-color: #4c4b4b;
  }
}
</style>
